import { render } from "./EditWallet.vue?vue&type=template&id=10d36b11"
import script from "./EditWallet.vue?vue&type=script&lang=js"
export * from "./EditWallet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__